import { useQuery } from '@apollo/client'
import { SearchableCombobox, TSearchable } from '../base/combobox'
import { ClientSelectorQuery, SelectedClientSelectorQuery } from './__generated__/selector_query'
import { Query, SelectedQuery } from './selector_query'
import { Badge } from '../client_type/badge'
import { useCombobox } from '@/helpers/useCombobox'
import { dedupe } from '@/helpers/dedupe'

type Client = SelectedClientSelectorQuery['clients']['nodes'][0]

interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { data: selectedData } = useQuery<SelectedClientSelectorQuery>(
    SelectedQuery,
    { variables: { id: value || 'blank' } }
  )
  const { data, loading, refetch, fetchMore } = useQuery<ClientSelectorQuery>(Query)

  const { pageInfo, items } = useCombobox<Client>({
    pageInfo: data?.clients.pageInfo,
    querySelected: selectedData?.clients.nodes[0],
    queryCollection: data?.clients.nodes,
    buildSearchable: item => ({
      id: item.id,
      name: item.organisationName,
      detail: <Badge clientType={item.clientType} />
    })
  })

  return (
    <SearchableCombobox
      data={items}
      includeBlank={false}
      invalid={invalid}
      loading={loading}
      moreToFetch={pageInfo.current?.hasNextPage}
      refetch={refetch}
      searchField="organisationNameCont"
      value={items.find(d => d.id == value) || { id: '', name: '' }}
      fetchMore={() => fetchMore({
        variables: { after: pageInfo.current?.endCursor },
        updateQuery(previousData, { fetchMoreResult }) {
          if (Object.keys(previousData).length === 0) return fetchMoreResult
          fetchMoreResult.clients.nodes = dedupe([
            ...previousData.clients.nodes,
            ...fetchMoreResult.clients.nodes
          ])

          return { ...fetchMoreResult }
        }
      })}
      onChange={onChange}
    />
  )
}
